import * as types from './types'
import storage from '@/plugins/storage'
import lookupStorageMap from './lookupStorageMap'

export default {
  [types.RESET_LOOKUPS](state) {
    state.lookups = {}
  },
  [types.SET_LOOKUPS](state, [keys, lookups]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      for (let lookup of lookups) {
        if (lookup.key === key) {
          lookup.value = lookup.intValue
          lookup.name = (lookup.text !== null) ? lookup.text : lookup.stringValue
          lookup.altValue = lookup.value
          _lookups[key].push(lookup)
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
  },
  [types.SET_LOOKUPS_ZEUS](state, [key, lookups]) {
    state.lookupsZeus[key] = []

    for (const lookup of lookups) {
      // accept either API shape or formatted shape
      const hasFormatted = lookup.name !== undefined && lookup.value !== undefined
      const formattedLookup = hasFormatted
        ? { name: lookup.name, value: lookup.value, altValue: lookup.altValue }
        : {
            name: lookup.text,
            value: key === 'device.applayerprotocol' ? lookup.value : lookup.id,
            altValue: lookup.value
          }

      state.lookupsZeus[key].push(formattedLookup)
    }

    const sessionKey = lookupStorageMap[key]
    if (sessionKey) {
      storage.local.setItem(sessionKey, JSON.stringify(state.lookupsZeus[key]))
    }
  },
  [types.SET_TIMEZONES](state, data) {
    state.timeZones = []
    let _timeZones = []
    for (let timezone of data) {
      timezone.value = timezone.name
      _timeZones.push(timezone)
    }
    state.timeZones = JSON.parse(JSON.stringify(Object.assign(state.timeZones, _timeZones)))
    storage.local.setItem(types.SESSION_TIMEZONES, JSON.stringify(state.timeZones))
  },
  [types.UPSERT_LOOKUP](state, [lookup, id]) {
    lookup.id = id
    let section = state.groups.filter(
      group => group.sectionName === lookup.section
    )
    if (section.length > 0) {
      let index = section[0].children.findIndex(i => i.id === lookup.id)
      if (index >= 0) {
        section[0].children[index] = {
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        }
      } else {
        section[0].children.push({
          id: lookup.id,
          key: lookup.key,
          section: lookup.section,
          text: lookup.text,
          value: lookup.stringValue,
          intValue: lookup.intValue,
          dateValue: lookup.dateValue
        })
      }
    }
  },

  [types.DELETE_LOOKUP](state, lookup) {
    try {
      let section = state.groups.filter(
        group => group.sectionName === lookup.section
      )
      if (section.length > 0) {
        let index = section[0].children.findIndex(i => i.id === lookup.id)
        section[0].children.splice(index, 1)
      }
    } catch (e) {
    }
  },
  [types.SET_GROUPS](state, groups) {
    state.groups = groups
  },
  [types.UPSERT_GROUP](state, data) {
    let group = state.groups.filter(
      g => g.id === data.id
    )
    if (group.length > 0) {
      group[0].sectionName = data.text
    }
  },
  [types.SET_INSURANCE_COMPANIES](state, companies) {
    state.insuranceCompanies = []
    if (companies && Array.isArray(companies)) {
      for (const item of companies) {
        // API sometimes returns {name,id}; cache is {name,value}
        const name = item.name
        const value = item.id ?? item.value ?? 0
        state.insuranceCompanies.push({ name, value })
      }
    }
    storage.local.setItem(types.SESSION_INSURANCECOMPANIES, JSON.stringify(state.insuranceCompanies))
  },
  [types.SET_VEHICLE_MAKES](state, makes) {
    state.vehicleMakes = []
    if (makes && Array.isArray(makes)) {
      for (const item of makes) {
        // API: {text,id}, cache: {name,value}
        const name = item.text ?? item.name ?? ''
        const value = item.id ?? item.value ?? 0
        state.vehicleMakes.push({ name, value })
      }
    }
    storage.local.setItem(types.SESSION_VEHICLEMAKES, JSON.stringify(state.vehicleMakes))
  },
  [types.SET_ODOMETERUNITS](state, units) {
    state.odometerunits = []
    if (units && Array.isArray(units)) {
      for (const item of units) {
        const name = item.text ?? item.name ?? ''
        const value = item.id ?? item.value ?? 0
        state.odometerunits.push({ name, value })
      }
    }
    storage.local.setItem(types.SESSION_ODOMETERUNITS, JSON.stringify(state.odometerunits))
  },
  [types.SET_DAMAGEPOSITIONS](state, positions) {
    state.damagepositions = positions
    storage.local.setItem(types.SESSION_DAMAGEPOSITIONS, JSON.stringify(state.damagepositions))
  },
  [types.SET_STATIC_DATA_LOADED](state, val) {
    state.staticDataLoaded = val
    storage.local.setItem(types.SESSION_STATIC_DATA_LOADED, val)
  },
  [types.SET_STATIC_DATA](state, payload) {
    state.timeZones = payload.timeZones
    state.insuranceCompanies = payload.insuranceCompanies
    state.vehicleMakes = payload.vehicleMakes
    state.odometerunits = payload.odometerunits
    state.damagepositions = payload.damagepositions
    state.lookupsZeus = payload.lookupsZeus
    state.staticDataLoaded = true
  },
  [types.RESET_STATIC_DATA](state) {
    state.timeZones = []
    state.insuranceCompanies = []
    state.vehicleMakes = []
    state.odometerunits = []
    state.damagepositions = []
    state.lookupsZeus = {}
    state.staticDataLoaded = false
  }
}
